import * as rtk from '@reduxjs/toolkit';
import { getCookies } from '../lib/cookies.js';
// @ts-expect-error ESM/CJS compatibility for `@reduxjs/toolkit`
const { combineReducers, configureStore } = ({ ...rtk }.default || rtk);
const PROD_DEV_TOOLS_COOKIE = 'CRYSTAL_REDUX_DEVTOOLS';
const DEV_TOOLS_OPTIONS = {
    name: 'Crystal Redux',
};
export class CrystalRedux {
    constructor(initialReducers, preloadedState, env) {
        this.staticReducers = Object.keys(initialReducers);
        this.reducers = initialReducers;
        const isDevToolsEnabled = env !== 'prod' ? true : getCookies()[PROD_DEV_TOOLS_COOKIE] === 'true';
        this.store = configureStore({
            reducer: this.reducers,
            preloadedState,
            devTools: isDevToolsEnabled ? DEV_TOOLS_OPTIONS : false,
        });
    }
    getStore() {
        return this.store;
    }
    registerReducer(name, reducer, replace = false) {
        if (!replace && this.reducers[name]) {
            throw new Error(`Reducer: ${name} is already registered.`);
        }
        if (replace && this.staticReducers.includes(name)) {
            throw new Error(`Reducer: ${name} is a static Reducer. It can not be replaced.`);
        }
        this.reducers[name] = reducer;
        this.store.replaceReducer(combineReducers(this.reducers));
    }
    unregisterReducer(name) {
        if (this.staticReducers.includes(name)) {
            throw new Error(`Reducer: ${name} is a static Reducer. It can not be unregister.`);
        }
        delete this.reducers[name];
        this.store.replaceReducer(combineReducers(this.reducers));
    }
    isReducerRegistered(name) {
        return !!this.reducers[name];
    }
}
//# sourceMappingURL=crystal-redux.js.map